import {Box} from '@mui/material'
import {Chart as ChartJS, ArcElement, Plugin, ChartOptions} from 'chart.js'
import React, {FC, useMemo} from 'react'
import {Doughnut} from 'react-chartjs-2'

type ProgressDoughnutChartProps = {
  data: number[]
  backgroundList: string[]
  pluginsList?: Plugin<'doughnut'>[]
  options?: ChartOptions<'doughnut'>
}

ChartJS.register(ArcElement)

export const ProgressDoughnutChart: FC<ProgressDoughnutChartProps> = ({
  data,
  backgroundList,
  pluginsList,
  options
}) => {
  const chartData = useMemo(() => {
    if (!data[1]) {
      return {
        datasets: [
          {
            data: [1, 0],
            backgroundColor: backgroundList
          }
        ]
      }
    }

    const calculatePercentageParts = (data: number[]): number[] => {
      const used = (data[0] / data[1]) * 100
      const remaining = 100 - used

      return [remaining, used]
    }

    return {
      datasets: [
        {
          data: calculatePercentageParts(data),
          backgroundColor: backgroundList
        }
      ]
    }
  }, [data, backgroundList])

  return (
    <Box height="inherit" overflow="hidden">
      <Doughnut data={chartData} options={options} plugins={pluginsList} />
    </Box>
  )
}
